<template>
    <div>
        <typo :class="cspClasses" name="ci-body" v-html="annotation.body"> </typo>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    props: ["annotation"],
    computed: {
        cspClasses() {
            return this.annotation.cspCodes
                .map(code => `csp-${code}`)
                .join(" ")
                .toLowerCase();
        },
    },
});
</script>

<style lang="sass"></style>
